/* eslint-disable no-restricted-globals */
/* eslint-disable prettier/prettier */
;(()=> {
    if (location && location.hash) {
        setTimeout(() => window.scrollTo(0, 0), 1);
    }
})();